import { School } from "lucide-react"

export default function PlannerStartStep() {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex items-center gap-2">
        <span className="w-fit rounded-lg bg-primary-50 p-1.5">
          <School className="size-4 text-primary-500" />
        </span>
        <h1 className="text-base font-bold">Planificador</h1>
      </header>
      <img
        className="w-full object-contain"
        src="https://storage.googleapis.com/educabot-aec-cdn-1/tuni/product-tour/planner-start.gif"
      />
      <p className="text-left text-sm text-muted-foreground">
        En esta sección vas a ver tu cursada organizada por semana: las materias que estás cursando
        y sus objetivos. Es tu panorama completo para que puedas planificar y avanzar con confianza.
      </p>
    </section>
  )
}
